export default __webpack_public_path__ + "static/media/steel-type.09bf4c2e.svg";